<template>
  <tabs v-model="activeTabsName" :data="tabsNavList" v-if="visible">
    <template v-if="activeTabsName == 'first'" v-loading="drawerTableLoading">
      <el-card shadow="never" slot="card" style="border: none;">
        <el-row v-if="locationSearch.tag.match(/ZCZ/i)" type="flex" style="flex-wrap: wrap;">
          <el-col :span="8">
            <label>入库仓库:</label><span>{{detailDrawerHeader.inWarehouseName }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库仓库:</label><span>{{detailDrawerHeader.outWarehouseName }}</span>
          </el-col>
          <el-col :span="8">
            <label>单号:</label><span>{{detailDrawerHeader.billNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>录单人:</label><span>{{detailDrawerHeader.entryUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>录单时间:</label><span>{{detailDrawerHeader.entryDate }} {{ detailDrawerHeader.entryTime }}</span>
          </el-col>
          <el-col :span="8">
            <label>状态:</label><span>{{detailDrawerHeader.billStatusStr }}</span>
          </el-col>
          <el-col :span="8">
            <label>审核人:</label><span>{{detailDrawerHeader.recordedUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>审核时间:</label><span>{{detailDrawerHeader.recordedDate }} {{ detailDrawerHeader.recordedTime }}</span>
          </el-col>
          <el-col :span="8">
            <label>备注:</label><span>{{detailDrawerHeader.remark }}</span>
          </el-col>
        </el-row>
        <!-- 出库单 -->
        <el-row v-else-if="locationSearch.tag.match(/CK/i)" type="flex" style="flex-wrap: wrap;">
          <el-col :span="8">
            <label>客户:</label><span>{{detailDrawerHeader.customerName }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库单号:</label><span>{{detailDrawerHeader.billNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>原单据号:</label><span>{{detailDrawerHeader.sourceBillNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库仓库:</label><span>{{detailDrawerHeader.warehouseName }}</span>
          </el-col>
          <el-col :span="8">
            <label>业务员:</label><span>{{detailDrawerHeader.salesmanName }}</span>
          </el-col>
          <el-col :span="8">
            <label>原单据类型:</label><span>{{detailDrawerHeader.sourceBillTypeStr }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库人:</label><span>{{detailDrawerHeader.outInUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库时间:</label><span>{{detailDrawerHeader.outInTime }}</span>
          </el-col>
          <el-col :span="8">
            <label>状态:</label><span>{{detailDrawerHeader.billStatusStr }}</span>
          </el-col>
          <el-col :span="16">
            <label>备注:</label><span>{{detailDrawerHeader.remark }}</span>
          </el-col>
        </el-row>
        <!-- 入库单 -->
        <el-row v-else-if="locationSearch.tag.match(/RK/i)" type="flex" style="flex-wrap: wrap;">
          <el-col :span="8" v-if="detailDrawerHeader.sourceBillType != 'ZC'">
            <label>客户:</label><span>{{detailDrawerHeader.customerName }}</span>
          </el-col>
          <el-col :span="8">
            <label>入库单号:</label><span>{{detailDrawerHeader.billNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>原单据号:</label><span @click="detailsHandle()" :style="{ color: getBillColor(detailDrawerHeader.sourceBillType) }">{{detailDrawerHeader.sourceBillNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>入库仓库:</label><span>{{detailDrawerHeader.warehouseName }}</span>
          </el-col>
          <el-col :span="8" v-if="detailDrawerHeader.sourceBillType != 'ZC'">
            <label>业务员:</label><span>{{detailDrawerHeader.salesmanName }}</span>
          </el-col>
          <el-col :span="8">
            <label>原单据类型:</label><span>{{detailDrawerHeader.sourceBillTypeStr }}</span>
          </el-col>
          <el-col :span="8">
            <label>入库人:</label><span>{{detailDrawerHeader.outInUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>入库时间:</label><span>{{detailDrawerHeader.outInTime }}</span>
          </el-col>
          <el-col :span="8">
            <label>状态:</label><span>{{detailDrawerHeader.billStatusStr }}</span>
          </el-col>
          <el-col :span="16">
            <label>备注:</label><span>{{detailDrawerHeader.remark }}</span>
          </el-col>
        </el-row>
        <!-- 访销单 -->
        <el-row v-else-if="locationSearch.tag.match(/FX/i)" type="flex" style="flex-wrap: wrap;">
          <el-col :span="8">
            <label>客户:</label><span>{{detailDrawerHeader.customerName }}</span>
          </el-col>
          <el-col :span="8">
            <label>单据号:</label><span>{{detailDrawerHeader.billNo }}</span>
          </el-col>
          <el-col :span="8">
            <label>单据类型:</label><span>{{detailDrawerHeader.billTypeStr }}</span>
          </el-col>
          <el-col :span="8">
            <label>单据日期:</label><span>{{detailDrawerHeader.billDate }}</span>
          </el-col>
          <el-col :span="8">
            <label>业务员:</label><span>{{detailDrawerHeader.salesmanName }}</span>
          </el-col>
          <el-col :span="8">
            <label>出库仓库:</label><span>{{detailDrawerHeader.warehouseName }}</span>
          </el-col>
          <el-col :span="8">
            <label>配送员:</label><span>{{detailDrawerHeader.deliverUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>配送车辆:</label><span>{{detailDrawerHeader.vehicleName }}</span>
          </el-col>
          <el-col :span="8">
            <label>协送员:</label><span>{{detailDrawerHeader.assistedUserName }}</span>
          </el-col>
          <el-col :span="8">
            <label>收款信息:</label><span>{{detailDrawerHeader.collectionInfo }}</span>
          </el-col>
          <el-col :span="8">
            <label>签收时间:</label><span>{{detailDrawerHeader.signTime }}</span>
          </el-col>
          <el-col :span="8">
            <label>单据状态:</label><span>{{detailDrawerHeader.signOrderStatus }}</span>
          </el-col>
          <el-col :span="24">
            <label>备注:</label><span>{{detailDrawerHeader.remark }}</span>
          </el-col>
        </el-row>
        <el-row v-else type="flex" style="flex-wrap: wrap;">
          <el-col :span="8" v-if="!locationSearch.tag.match(/PKD|BSD/i)"><label>客户:</label><span>{{
            detailDrawerHeader.customerName }}</span></el-col>
          <el-col :span="8" v-if="locationSearch.tag.match(/PKD|BSD/i)"><label>盘点人:</label><span>{{
            detailDrawerHeader.entryUserName }}</span></el-col>
          <el-col :span="8" v-if="!locationSearch.tag.match(/CGD|CGT|BSD/i)"><label>业务员:</label><span>{{
            detailDrawerHeader.salesmanName }}</span></el-col>
          <el-col :span="8" v-if="locationSearch.tag.match(/DHD/i)"><label>订货会:</label><span>{{
            detailDrawerHeader.salOrderMeetName }}</span></el-col>
          <el-col :span="8" v-else><label>{{ locationSearch.tag.match(/CGD|XST/i) ? '入库' :
            (locationSearch.tag.match(/PKD|BSD/i) ? '盘点' : '出库') }}仓库:</label><span>{{ detailDrawerHeader.warehouseName
  }}</span></el-col>
          <el-col :span="8"><label>{{ locationSearch.tag.match(/CGD|XST/i) ? '入库' : (locationSearch.tag.match(/PKD|BSD/i) ?
            '盘点' : (locationSearch.tag.match(/DHD/i) ? '' : '出库')) }}单号:</label><span>{{ detailDrawerHeader.billNo
  }}</span></el-col>
          <el-col :span="8"><label>制单人:</label><span>{{ detailDrawerHeader.entryUserName }}</span></el-col>
          <el-col :span="8"><label>制单时间:</label><span style="margin-right: 6px;">{{ detailDrawerHeader.entryDate
          }}</span><span>{{ detailDrawerHeader.entryTime }}</span></el-col>
          <el-col :span="8"><label>状态:</label><el-tag size="small"
              :type="(['FOD', 'JOD'].includes(locationSearch.tag) && detailDrawerHeader.billStatus) ? 'success' : billStatusItem[detailDrawerHeader.billStatus]">{{ detailDrawerHeader.billStatusStr
              }}</el-tag></el-col>
          <el-col :span="8" v-if="locationSearch.tag.match(/DHD/i)">
            <label>操作:</label>
            <el-button-group style="display: inline-block; height: auto;">
              <el-button type="text" size="mini" @click="operateBill('copy', detailDrawerHeader.billNo, 'copy')"
                v-if="btnPower.isCopy == 'Y' && detailDrawerHeader.meetType == 'A'">复制</el-button>
              <el-button
                v-show="btnPower.isRedStrik == 'Y' && power.isAllowRed == 'Y' && detailDrawerHeader.billStatus == 'B'"
                style="margin-left: 6px; color: #F56C6C;" type="text" size="mini"
                @click="operateBill('red', detailDrawerHeader.billNo)">红冲</el-button>
              <el-button v-show="btnPower.isEdit == 'Y' && detailDrawerHeader.billStatus == 'A'"
                style="margin-left: 6px; color: #67C23A;" type="text" size="mini"
                @click="operateBill('edit', detailDrawerHeader.billNo, 'edit')">编辑</el-button>
              <el-button v-show="btnPower.isCancel == 'Y' && detailDrawerHeader.billStatus == 'A'"
                style="margin-left: 6px; color: #909399;" type="text" size="mini"
                @click="operateBill('cancel', detailDrawerHeader.billNo)">作废</el-button>
              <!-- <el-button v-if="btnPower.isPrint == 'Y'" style="margin-left: 6px; color: rgb(96, 98, 102);" type="text" size="mini" @click="printTable(detailDrawerHeader.billNo)">打印</el-button>
              <el-button v-show="btnPower.isExport == 'Y' && ['PKD', 'XSD', 'CGD', 'CGT'].includes(locationSearch.tag)" style="margin-left: 6px; color: #67c23a;" type="text" size="mini" @click="exportTable(detailDrawerHeader.billNo)">导出</el-button> -->
            </el-button-group>
          </el-col>
          <el-col :span="8" v-if="locationSearch.tag.match(/DHD/i)"><label>单据来源:</label><span>{{
            detailDrawerHeader.isFromVehicle }}</span></el-col>
          <el-col :span="8"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
          <el-col :span="8"
            v-show="tabsActiveArr[0] == 'A' && !locationSearch.tag.match(/PKD|DHD|BSD/i) && detailDrawerHeader.billStatus != 'A'"><label>收款信息:</label><span>{{
              detailDrawerHeader.collectionInfo }}</span></el-col>
          <el-col :span="8" v-if="locationSearch.tag.match(/DHD/i)"><label>收款信息:</label><span>{{
            detailDrawerHeader.collectionInfo }}</span></el-col>
          <el-col :span="8" v-if="detailDrawerHeader.billStatus != 'A' && !['JOD', 'FOD'].includes(locationSearch.tag)"><label>审核人:</label><span>{{
            detailDrawerHeader.recordedUserName }}</span></el-col>
          <el-col :span="8" v-if="detailDrawerHeader.billStatus != 'A' && !['JOD', 'FOD'].includes(locationSearch.tag)"><label>审核时间:</label><span
              style="margin-right: 6px;">{{ detailDrawerHeader.recordedDate }}</span><span>{{
                detailDrawerHeader.recordedTime }}</span></el-col>
        </el-row>
        <div class="tips" v-if="locationSearch.tag.match(/PKD/i)">
          <span style="color: #909399;">未盘：<span>{{ inventoryStatusCountN }}</span></span>
          <span style="color: #409EFF; margin-left: 6px;">盘平：<span>{{ inventoryStatusCountC }}</span></span>
          <span style="color: #67C23A; margin-left: 6px;">盘盈：<span>{{ inventoryStatusCountB }}</span></span>
          <span style="color: #F56C6C; margin-left: 6px;">盘亏：<span>{{ inventoryStatusCountA }}</span></span>
        </div>
      </el-card>
      <el-table v-if="locationSearch.tag.match(/ZCZ/i)" size="mini" :data="detailDrawerTable" border stripe height="100%" max-height="100%" :summary-method="getTableSummaries" show-summary>
        <el-table-column class-name="index" type="index" width="30"></el-table-column>
        <el-table-column label="状态" prop="ioType" width="140"></el-table-column>
        <el-table-column label="商品名称" prop="itemName" width="140"></el-table-column>
        <!-- <el-table-column label="规格" prop="itemSpec" width="140"></el-table-column> -->
        <el-table-column label="生产日期" prop="productionDate" width="140"></el-table-column>
        <el-table-column label="数量" prop="" width="140">
          <template slot-scope="scope">
            <div>
              <span v-show="scope.row.salUnitName">
                <span>{{ Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.salUnitName }}</span>
              </span>
              <span v-show="scope.row.midUnitName">
                <span>{{ Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.midUnitName }}</span>
              </span>
              <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                <span>{{ Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="折算小单位" prop="invUnitName" width="140">
          <template slot-scope="scope">
            <!-- <div style="font-size: 12px; color: #F56C6C;"> -->
            <div style="font-size: 12px;">
              <span>{{ scope.row.invQty }}</span>
              <span>{{ scope.row.invUnitName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
      </el-table>
      <!-- 出库和入库 -->
      <el-table v-else-if="locationSearch.tag.match(/CK/i) || locationSearch.tag.match(/RK/i)" ref="detailDrawerTable" size="mini" :data="detailDrawerTable" border stripe height="100%" max-height="100%" :summary-method="getTableSummariesNew" show-summary>
        <el-table-column class-name="index" type="index" width="40"></el-table-column>
        <el-table-column label="商品" prop="itemName" width="140"></el-table-column>
        <el-table-column label="规格" prop="itemSpec" width="140"></el-table-column>
        <el-table-column label="业务属性" prop="billPromotionTypeFormat" v-if="detailDrawerHeader.sourceBillType != 'ZC'" width="140"></el-table-column>
        <el-table-column label="销售形式" prop="isLargessFormat" width="140"></el-table-column>
        <el-table-column label="数量" prop="billQtyFormat" width="140"></el-table-column>
        <el-table-column label="折算小单位" prop="invQtyFormat" width="140"></el-table-column>
        <el-table-column label="生产日期" prop="productionDate" width="140">
          <template slot-scope="{ row }">
            <div v-if="row.productionDateList && row.productionDateList.length" style="display: flex; flex-direction: column;">
              <span v-for="item in row.productionDateList" :key="item.productionDate">{{ item.productionDate }}</span>
            </div>
            <div v-else>{{ row.productionDate }}</div>
          </template>
        </el-table-column>
        <el-table-column label="大单位条码" prop="salBarCode" width="140"></el-table-column>
        <el-table-column label="中单位条码" prop="midBarCode" width="140"></el-table-column>
        <el-table-column label="小单位条码" prop="invBarCode" width="140"></el-table-column>
        <el-table-column label="备注" prop="remark" min-width="100"></el-table-column>
      </el-table>
      <!-- 访销单 -->
      <el-table v-else-if="locationSearch.tag.match(/FX/i)" ref="detailDrawerTable" size="mini" :data="detailDrawerTable" border stripe height="100%" max-height="100%" :summary-method="getTableSummariesNew" show-summary>
        <el-table-column class-name="index" type="index" width="30"></el-table-column>
        <el-table-column label="商品" prop="itemName" width="140"></el-table-column>
        <el-table-column label="规格" prop="itemSpec" width="140"></el-table-column>
        <el-table-column label="业务属性" prop="billPromotionTypeFormat" width="140"></el-table-column>
        <el-table-column label="销售形式" prop="isLargessFormat" width="140"></el-table-column>
        <el-table-column label="退货原因" prop="causeDesc" v-if="detailDrawerHeader.billType != 'DH'" width="140"></el-table-column>
        <el-table-column label="数量" prop="billQtyFormat" width="140"></el-table-column>
        <el-table-column label="折算小单位" prop="invQtyFormat" width="140"></el-table-column>
        <el-table-column label="签收数量" prop="consignUnitQtyFormat" width="140"></el-table-column>
        <el-table-column label="折算小单位" prop="invConsignQtyFormat" width="140"></el-table-column>
        <el-table-column label="单价" prop="signPriceFormat" width="140"></el-table-column>
        <el-table-column label="金额" prop="totalAmt" width="140"></el-table-column>
        <el-table-column label="出库生产日期" prop="productionDate" width="140"></el-table-column>
        <el-table-column label="入库生产日期" prop="returnProductionDate" width="140"></el-table-column>
        <el-table-column label="口味" prop="flavorDesc" width="100"></el-table-column>
        <el-table-column label="大单位条码" prop="salBarCode" width="140"></el-table-column>
        <el-table-column label="中单位条码" prop="midBarCode" width="140"></el-table-column>
        <el-table-column label="小单位条码" prop="invBarCode" width="140"></el-table-column>
        <el-table-column label="备注" prop="remark" min-width="100"></el-table-column>
      </el-table>
      <el-table v-else ref="detailDrawerTable" size="mini" :data="detailDrawerTable" border stripe height="100%"
        max-height="100%" :summary-method="getTableSummaries" show-summary @filter-change="filterMethod">
        <el-table-column class-name="index" type="index" width="30"></el-table-column>
        <el-table-column v-if="locationSearch.tag.match(/PKD/i)" label="商品" column-key="itemName" prop="itemName"
          width="180" :filters="profitAndlossFilter" :filtered-value="profitAndlossFilterValue">
          <template slot-scope="scope">
            <span>{{ scope.row.itemName }}</span>
            <el-tag v-show="scope.row.isDiffPrice == 'Y'" key="isMove"
              style="color: rgba(0, 206, 209, 1); background-color: rgba(0, 206, 209, 0.1)" size="mini">变</el-tag>
            <div>
              <el-tag size="mini"
                :type="scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].type : 'info'">{{
                  scope.row.checkedStatus == 'Y' ? profitAndlossStatus[scope.row.profitAndlossStatus].text : '未盘'
                }}</el-tag>
              <span>{{ scope.row.itemSpec }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-else label="商品" prop="itemName" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.itemName }}</span>
            <el-tag v-show="scope.row.isDiffPrice == 'Y'" key="isMove"
              style="color: rgba(0, 206, 209, 1); background-color: rgba(0, 206, 209, 0.1)" size="mini">变</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="locationSearch.tag != 'PKD'" label="规格" prop="itemSpec" width="100"></el-table-column>
        <el-table-column v-if="!locationSearch.tag.match(/CGT|PKD|JHD|JRD|FHD|FOD|JOD|BSD/i)"
          :label="(locationSearch.tag == 'CGD' ? '采购' : (locationSearch.tag == 'XST' ? '退货' : '销售')) + '形式'"
          prop="isLargessFormat" width="80"></el-table-column>
        <el-table-column v-if="locationSearch.tag.match(/CGT|XST/i)" label="退货原因" prop="causeDesc"
          width="80"></el-table-column>
        <el-table-column v-if="locationSearch.tag.match(/PKD|BSD/i)" label="账面数量" prop="bookBillQty" width="140">
          <template slot-scope="scope">
            <div>
              <span v-show="scope.row.salUnitName && getUnit('sal', scope.row.salUnitConversion, getAdjustQty(scope, 'onhandQty4Sal'))">
                <!-- <span>{{ Number((Number(scope.row.onhandQty4Sal) || 0).toFixedRoundUp(2)) }}</span> -->
                <span>{{ getAdjustQty(scope, 'onhandQty4Sal') }}</span>
                <span>{{ scope.row.salUnitName }}</span>
              </span>
              <span v-show="scope.row.midUnitName && getUnit('mid', scope.row.salUnitConversion, 0, getAdjustQty(scope, 'onhandQty4Mid'))">
                <!-- <span>{{ Number((Number(scope.row.onhandQty4Mid) || 0).toFixedRoundUp(2)) }}</span> -->
                <span>{{ getAdjustQty(scope, 'onhandQty4Mid') }}</span>
                <span>{{ scope.row.midUnitName }}</span>
              </span>
              <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName &&
                getUnit('inv', scope.row.salUnitConversion,
                  getAdjustQty(scope, 'onhandQty4Sal'),
                  getAdjustQty(scope, 'onhandQty4Mid'),
                  getAdjustQty(scope, 'onhandQty4Inv'),
                  scope.row.midUnitName
                )
              ">
                <!-- <span>{{ Number((Number(scope.row.onhandQty4Inv) || 0).toFixedRoundUp(2)) }}</span> -->
                <span>{{ getAdjustQty(scope, 'onhandQty4Inv') }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </span>
            </div>
            <!-- <div style="font-size: 12px; color: #F56C6C;"> -->
            <div style="font-size: 12px;">
              <span>折算:</span>
              <span>{{ Number(scope.row.onhandQty) || 0 }}</span>
              <span>{{ scope.row.invUnitName }}</span>
            </div>
          </template>
        </el-table-column>
        <template v-if="!locationSearch.tag.match(/BSD/i)">
          <el-table-column v-if="!locationSearch.tag.match(/PKD/i)" label="数量" prop="billQty" width="140">
            <template slot-scope="scope">
              <div>
                <span v-show="scope.row.salUnitName">
                  <span>{{ Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                  <span>{{ scope.row.salUnitName }}</span>
                </span>
                <span v-show="scope.row.midUnitName">
                  <span>{{ Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                  <span>{{ scope.row.midUnitName }}</span>
                </span>
                <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                  <span>{{ Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                  <span>{{ scope.row.invUnitName }}</span>
                </span>
              </div>
              <!-- <div style="font-size: 12px; color: #F56C6C;"> -->
              <div style="font-size: 12px;">
                <span>折算:</span>
                <span>{{ scope.row.invQty }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else label="盘点数量" prop="billQty" width="140">
            <template slot-scope="scope">
              <div>
                <span v-show="scope.row.salUnitName && getUnit('sal', scope.row.salUnitConversion, getAdjustQty(scope, 'salUnitQty'))">
                  <span>{{ getAdjustQty(scope, 'salUnitQty') }}</span>
                  <!-- <span>{{ Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2)) }}</span> -->
                  <span>{{ scope.row.salUnitName }}</span>
                </span>
                <span v-show="scope.row.midUnitName && getUnit('mid', scope.row.salUnitConversion, 0, getAdjustQty(scope, 'midUnitQty'))">
                  <span>{{ getAdjustQty(scope, 'midUnitQty') }}</span>
                  <!-- <span>{{ Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2)) }}</span> -->
                  <span>{{ scope.row.midUnitName }}</span>
                </span>
                <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName && getUnit('inv', scope.row.salUnitConversion, getAdjustQty(scope, 'salUnitQty'), getAdjustQty(scope, 'midUnitQty'), getAdjustQty(scope, 'invUnitQty'), scope.row.midUnitName)">
                  <span>{{ getAdjustQty(scope, 'invUnitQty') }}</span>
                  <!-- <span>{{ Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2)) }}</span> -->
                  <span>{{ scope.row.invUnitName }}</span>
                </span>
              </div>
              <div style="font-size: 12px;">
                <span>折算:</span>
                <span>{{ (Number(scope.row.realQty) || 0) }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column v-if="locationSearch.tag.match(/PKD/i)" label="调整数量" prop="adjustmentBillQty" width="140">
          <template slot-scope="scope">
            <div>
              <span v-show="scope.row.salUnitName && getUnit('sal', scope.row.salUnitConversion,
                getAdjustQty(scope, 'adjustQty4Sal')
              )">
                <span>{{ getAdjustQty(scope, 'adjustQty4Sal') }}</span>
                <span>{{ scope.row.salUnitName }}</span>
              </span>
              <span v-show="scope.row.midUnitName && getUnit('mid', scope.row.salUnitConversion, 0,
                getAdjustQty(scope, 'adjustQty4Mid')
              )">
                <span>{{ getAdjustQty(scope, 'adjustQty4Mid') }}</span>
                <span>{{ scope.row.midUnitName }}</span>
              </span>
              <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName && getUnit('inv', scope.row.salUnitConversion,
                getAdjustQty(scope, 'adjustQty4Sal'),
                getAdjustQty(scope, 'adjustQty4Mid'),
                getAdjustQty(scope, 'adjustQty4Inv'),
                scope.row.midUnitName 
              )">
                <span>{{ getAdjustQty(scope, 'adjustQty4Inv') }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </span>
            </div>
            <!-- <div style="font-size: 12px; color: #F56C6C;"> -->
            <div style="font-size: 12px;">
              <span>折算:</span>
              <span>{{ Number(scope.row.adjustQty) || 0 }}</span>
              <span>{{ scope.row.invUnitName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="locationSearch.tag.match(/BSD/i)" label="报损数量" prop="billAdjustQty" width="140">
          <template slot-scope="scope">
            <div>
              <span v-show="scope.row.salUnitName && getUnit('sal', scope.row.salUnitConversion, Number((Number(scope.row.adjustQty4Sal) || 0).toFixedRoundUp(2)))">
                <span>{{ Number((Number(scope.row.adjustQty4Sal) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.salUnitName }}</span>
              </span>
              <span v-show="scope.row.midUnitName && getUnit('mid', scope.row.salUnitConversion, 0, Number((Number(scope.row.adjustQty4Mid) || 0).toFixedRoundUp(2)))">
                <span>{{ Number((Number(scope.row.adjustQty4Mid) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.midUnitName }}</span>
              </span>
              <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName && getUnit('inv', scope.row.salUnitConversion, Number((Number(scope.row.adjustQty4Sal) || 0).toFixedRoundUp(2)), Number((Number(scope.row.adjustQty4Mid) || 0).toFixedRoundUp(2)), Number((Number(scope.row.adjustQty4Inv) || 0).toFixedRoundUp(2)), scope.row.midUnitName)">
                <span>{{ Number((Number(scope.row.adjustQty4Inv) || 0).toFixedRoundUp(2)) }}</span>
                <span>{{ scope.row.invUnitName }}</span>
              </span>
            </div>
            <!-- <div style="font-size: 12px; color: #F56C6C;"> -->
            <div style="font-size: 12px;">
              <span>折算:</span>
              <span>{{ Number(scope.row.availableQty) || 0 }}</span>
              <span>{{ scope.row.invUnitName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="billPrice" width="140"
          v-if="tabsActiveArr[0] != 'C' && !locationSearch.tag.match(/PKD|BSD/i) && allowCostPrice"><template slot="header" slot-scope="scope">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">
                单价<span style="color: #666">(元/单位)</span>
              </span>
              <span v-if="locationSearch.tag.match(/DBD/i) && $store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A'">{{ scope.column.label }}（成本价）</span>
              <span v-if="locationSearch.tag.match(/DBD/i) && $store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B'">{{ scope.column.label }}（标准价）</span>
              <span v-if="locationSearch.tag.match(/DBD/i) && $store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C'">{{ scope.column.label }}（承包价）</span>
          </template>
          <template slot-scope="scope">
            <span v-show="scope.row.salUnitName">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.salUnitPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.salCostPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.salUnitPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.salContractPrice || 0).toFixedRoundUp(4)) }}</span>
              <span>/{{ scope.row.salUnitName }}</span>
            </span>
            <span v-show="scope.row.midUnitName">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">{{ Number((Number(scope.row.midUnitPrice) || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.midCostPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.midUnitPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.midContractPrice || 0).toFixedRoundUp(4)) }}</span>
              <span>/{{ scope.row.midUnitName }}</span>
            </span>
            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">{{ Number((Number(scope.row.invUnitPrice) || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.invCostPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.invUnitPrice || 0).toFixedRoundUp(4)) }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C' && locationSearch.tag.match(/DBD/i)">{{ Number(Number(scope.row.invContractPrice || 0).toFixedRoundUp(4)) }}</span>
              <span>/{{ scope.row.invUnitName }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="总金额" prop="amt" width="120"
          v-if="tabsActiveArr[0] != 'C' && !locationSearch.tag.match(/PKD|BSD/i) && allowCostPrice">
          <template slot="header" slot-scope="scope">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">总金额</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A'">{{ scope.column.label }}（成本价）</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B'">{{ scope.column.label }}（标准价）</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C'">{{ scope.column.label }}（承包价）</span>
          </template>
          <template slot-scope="scope">
              <span v-if="$store.state.power.enterpriseVersion < 100 || !locationSearch.tag.match(/DBD/i)">{{ scope.row.amt }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'A'">{{ scope.row.costTotalAmt }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'B'">{{ scope.row.totalAmt }}</span>
              <span v-if="$store.state.power.enterpriseVersion >= 100 && detailDrawerHeader.moneyType == 'C'">{{ scope.row.contractPriceTotalAmt }}</span>
          </template>
          <!-- <template slot-scope="scope">
            {{ locationSearch.tag.match(/DHD/i) ? scope.row.totalAmt : scope.row.amt }}
          </template> -->
        </el-table-column>
        <el-table-column label="差额" prop="totalAmt" width="80"
          v-if="locationSearch.tag.match(/PKD|BSD/i) && power.isShowCheckTotalAmt == 'Y'"></el-table-column>
        <el-table-column v-if="!locationSearch.tag.match(/PKD|DHD/i)" label="生产日期" prop="productionDate"
          width="100"></el-table-column>
        <el-table-column v-if="locationSearch.tag.match(/PKD/i) && power.isEnableProductDate == 'Y'" label="生产日期"
          prop="productionDate" width="100"></el-table-column>
        <el-table-column label="条码" prop="invBarCode" v-if="!locationSearch.tag.match(/DHD|JHD|JRD|FHD|FOD/i)" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.salBarCode">
              <span>{{ scope.row.salBarCode }}</span><span>/大</span>
            </div>
            <div v-if="scope.row.midBarCode">
              <span>{{ scope.row.midBarCode }}</span><span>/中</span>
            </div>
            <div v-if="scope.row.invBarCode">
              <span>{{ scope.row.invBarCode }}</span><span>/小</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="!locationSearch.tag.match(/CGD|CGT|PKD|DHD/i)" label="口味" prop="flavorDesc"
          width="80"></el-table-column>
        <el-table-column label="备注" prop="remark" width="140"></el-table-column>
      </el-table>
    </template>
    <template v-else-if="activeTabsName == 'second'" v-loading="drawerBarandArrearTableLoading">
      <div class="barandArrear_top" slot="card">
        <p>总金额({{ detailInfo.totalAmt }}) = 现金({{ detailInfo.cashsPayAmt }}) +
          {{ detailInfo.accountName }}({{ detailInfo.othersPayAmt }}) + 折扣({{ detailInfo.discountAmt }}) +
          欠款({{ detailInfo.arrearAmt }}) + 预收({{ detailInfo.prePayAmt }}) + 冲抵销售({{ detailInfo.offsetAmt }})</p>
      </div>
      <el-table ref="barandArrearDrawerTable" size="mini" :data="barandArrearDrawerTable" border stripe height="100%"
        max-height="100%" show-summary :summary-method="getSummaries">
        <el-table-column class-name="index" type="index" width="30"></el-table-column>
        <el-table-column label="财务品牌" prop="financialBrandName" width="180"></el-table-column>
        <el-table-column label="欠款" prop="billArrearBalance" width="100"></el-table-column>
      </el-table>
    </template>
    <template v-else-if="activeTabsName == 'third'">
      <el-table ref="barandArrearDrawerTable" :data="cleanArrearsDetail" size="mini" border stripe height="100%"
        max-height="100%" show-summary :summary-method="getSummaries">
        <el-table-column class-name="index" type="index" width="30"></el-table-column>
        <el-table-column label="日期" prop="entryDateTime" width="120"></el-table-column>
        <el-table-column label="品牌" prop="brandName" width="150"></el-table-column>
        <el-table-column label="变化金额" prop="changeAmt" width="100"></el-table-column>
        <el-table-column label="余额" prop="balance" width="100"></el-table-column>
        <el-table-column label="单据" prop="billNo" width="166"></el-table-column>
        <el-table-column label="备注" prop="remark" min-width="180"></el-table-column>
      </el-table>
    </template>
    <template v-else-if="activeTabsName == 'fourth'">
      <div class="customer-box">
        <template v-if="imgList.length > 0">
          <el-scrollbar class="customer-scroll" ref="customerScroll">
            <div class="customer-img-box">
              <div class="customer-img-item" v-for="(item, i) in imgList" :key="i">
                <div class="customer-img-img">
                  <el-image fit="cover" :src="item" @click="toLookBigImg(item, i)">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </template>
        <div class="zanwu" v-else>暂无数据</div>
      </div>
    </template>
    <el-image-viewer v-if="imgVisible" :initial-index="checkIndex" :on-close="closeViewer" :url-list="urlList" />
  </tabs>
</template>

<script>
import tabs from '@/components/common/tabs.vue'
import elImageViewer from '@/components/common/elImageViewer.vue'
export default {
  components: {
    tabs,
    elImageViewer
  },
  props: {
    // 对locationSearch.tag的补充， 比如销售出库、还货、换货，tag都为XSD，这个时候需要tabsActiveArr的补充
    tabsActiveArr: {
      type: Array,
      default() {
        return ['A']
      }
    },
    locationSearch: {
      type: Object
    },
    btnPower: {
      type: Object,
      default() {
        return {}
      }
    },
    power: {
      type: Object,
      default() {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  created() {
    console.log(this.locationSearch.tag.match(/ZCZ/i))
    // this.getDetailInfo({billNo: "XSD20220919105728681", billType: "XSD"})
    // this.getBarandArrearDetailInfo({billNo: "XSD20220919105728681", billType: "XSD"})
    if(this.power.enterpriseVersion >= 100){
      this.getPriceShow()
    }
  },
  computed: {
    tabsNavList() {
      let tabsNavList = [{ text: '单据详情', value: 'first' }]
      if (this.tabsActiveArr[0] == 'A' && this.barandArrearDrawerTable.length) {
        tabsNavList.push({ text: '品牌欠款', value: 'second' })
      }
      if (this.cleanArrearsDetail.length) {
        tabsNavList.push({ text: '清欠情况', value: 'third' })
      }
      if (this.tabsActiveArr[2] && this.tabsActiveArr[2] == 'showFuJian') {
        tabsNavList.push({ text: '附件', value: 'fourth' })
      }
      console.log(this.tabsActiveArr);
      console.log(tabsNavList);
      return tabsNavList
    }
  },
  data() {
    return {
      activeTabsName: 'first',
      detailDrawerHeader: {},
      detailDrawerTable: [],
      drawerTableLoading: false,
      barandArrearDrawerTable: [],
      drawerBarandArrearTableLoading: false,
      summaries: {},
      billStatusItem: {
        A: 'warning',
        B: 'success',
        C: 'danger',
        D: 'info'
      },
      profitAndlossFilter: [
        { text: '盘亏', value: 'A' },
        { text: '盘盈', value: 'B' },
        { text: '盘平', value: 'C' },
        { text: '未盘', value: 'N' }
      ],
      profitAndlossStatus: {
        A: { text: '盘亏', type: 'danger' },
        B: { text: '盘盈', type: 'success' },
        C: { text: '盘平', type: '' }
      },
      inventoryStatusCountN: 0,
      inventoryStatusCountA: 0,
      inventoryStatusCountB: 0,
      inventoryStatusCountC: 0,
      params: {},
      profitAndlossFilterValue: ['A', 'B', 'C', 'N'],
      detailInfo: {
        totalAmt: 0,
        payAmt: 0,
        cashsPayAmt: 0,
        othersPayAmt: 0,
        discountAmt: 0,
        arrearAmt: 0,
        prePayAmt: 0,
        offsetAmt: 0,
      },
      // 清欠情况
      drawerCleanArrearsDetailLoading: false,
      cleanArrearsDetail: [],
      imgList: [],
      checkIndex: 0,
      allowCostPrice: true,
      priceArgs: {
          url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
          code: 'isInventoryReport'
      },
      imgVisible: false,
      summariesCK: {}
    }
  },
  methods: {
    drawerClose() {
      this.activeTabsName = 'first'
      this.detailDrawerHeader = {}
      this.detailDrawerTable = []
      this.inventoryStatusCountN = 0
      this.inventoryStatusCountA = 0
      this.inventoryStatusCountB = 0
      this.inventoryStatusCountC = 0
      this.barandArrearDrawerTable = []
      this.cleanArrearsDetail = []
    },
    async getPriceShow() {
      const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
        if(this.locationSearch.tag.match(/DHD/i)){
          return false
        }
        if(this.locationSearch.tag.match(/PKD/i)) {
          if(this.power.isShowCheckTotalAmt == 'Y'){
            if(this.power.invCheckUsePrice == 'A'){
              this.power.isShowCheckTotalAmt = res.result
            }else {
              this.power.isShowCheckTotalAmt = 'Y'
            }
          }
        }else if(this.locationSearch.tag.match(/DBD/i)){
          if(this.power.isShowMoveTotalAmt == 'Y') {
            if(this.power.invMoveUsePrice == 'A'){
              this.allowCostPrice = res.result == 'Y'
            }else {
              this.allowCostPrice = true
            }
          }
        }
    },
    closeViewer() {
      this.imgVisible = false
    },
    toLookBigImg(item, index) {
      this.urlList = this.imgList
      this.checkIndex = index
      this.imgVisible = true
    },
    // 获取附件图片列表
    async getImageList(row) {
      this.drawerTableLoading = true
      console.log('getImageList', row)
      const { data: res } = await this.$http.post('/Account/billSearchVue/selectSalOrderAttachment.html', this.Qs.stringify({ billNo: row.billNo }))
      if (res.code != 'success') return this.$message.error(res.message)
      this.drawerTableLoading = false
      if (res.result) {
        res.result = JSON.parse(res.result)
        this.imgList = JSON.parse(res.result.data)
        // console.log(222,this.imgList)
      }
    },
    // 获取单据详情事件
    async getDetailInfo(params = {}) {
      if (Object.keys(params).length) {
        params['profitAndloss'] = "'A', 'B', 'C', 'N'"
        this.params = params
      } else {
        params = this.params
      }
      this.drawerTableLoading = true
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify(params))
      this.drawerTableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      const { headInfo, itemList: tableData, sum } = JSON.parse(res.result.data)
      console.log({ headInfo, tableData })
      this.detailDrawerHeader = headInfo
      this.detailDrawerTable = tableData
      this.summariesCK = JSON.parse(res.result.sum)
      console.log(this.summariesCK)
      let inventoryStatusCountN = 0
      let inventoryStatusCountA = 0
      let inventoryStatusCountB = 0
      let inventoryStatusCountC = 0
      tableData.forEach(i => {
        if (i.checkedStatus == 'Y') {
          if (i.profitAndlossStatus == 'A') {
            inventoryStatusCountA++
          } else if (i.profitAndlossStatus == 'B') {
            inventoryStatusCountB++
          } else if (i.profitAndlossStatus == 'C') {
            inventoryStatusCountC++
          }
        } else {
          inventoryStatusCountN++
        }
      })
      this.inventoryStatusCountN = inventoryStatusCountN
      this.inventoryStatusCountA = inventoryStatusCountA
      this.inventoryStatusCountB = inventoryStatusCountB
      this.inventoryStatusCountC = inventoryStatusCountC
    },
    // 获取单据分品牌欠款详情事件
    async getBarandArrearDetailInfo(params) {
      if (params.billSearchType == 'XST') {
        this.barandArrearDrawerTable = []
        this.summaries = []
        return false
      }
      this.drawerBarandArrearTableLoading = true
      const { data: res } = await this.$http.post('/Account/salConsignVue/selectSalConsignPayBalance.html', this.Qs.stringify(params))
      this.drawerBarandArrearTableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      this.getBarandArrearInfo(params)
      res.result = JSON.parse(res.result)
      this.barandArrearDrawerTable = JSON.parse(res.result.data)
      this.summaries = JSON.parse(res.result.sum)
    },
    async getBarandArrearInfo(params) {
      if (!['XSD', 'XST'].includes(params.billType)) return false
      const { data: res } = await this.$http.post('/Account/dataSearchVue/selectSalCollectionInfo.html', this.Qs.stringify(params))
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      this.detailInfo = JSON.parse(res.result.data)
    },
    // 获取清欠情况
    async getBarandCleanArrearsDetail(params) {
      this.tabsNavList.push({ text: '清欠情况', value: 'third' })
      this.drawerCleanArrearsDetailLoading = true
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/salCleanArrears/selectCleanArrearsDetail.html', params)
      this.drawerCleanArrearsDetailLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      this.cleanArrearsDetail = res.data
    },
    // 分品牌欠款合计
    getSummaries({ columns }) {
      const sums = []
      for (let k in this.summaries) {
        columns.forEach((column, index) => {
          if (index == 1) {
            sums[index] = '合计'
            return
          }
          if (column.property == k) {
            sums[index] = this.summaries[k]
            return
          }
        })
      }
      this.$nextTick(() => {
        this.$refs.barandArrearDrawerTable.doLayout()
      })
      return sums
    },
    // 单据详情合计
    getTableSummaries({ columns }) {
      const sums = []
      columns.forEach((item, index) => {
        if (index === 0) {
          sums[index] = '合';
          return;
        }
        if (item['property'] && item['property'] == 'itemName') {
          sums[index] = `共${this.detailDrawerTable.length}条`;
          return;
        }
        if (item['property'] && item['property'] == 'billQty') {
          if (this.locationSearch.tag.match(/PKD/i)) {
            sums[index] = this.detailDrawerHeader.billRealQty;
          } else {
            sums[index] = this.detailDrawerHeader.billQty;
          }
          return;
        }
        if (item['property'] && ['adjustmentBillQty', 'billAdjustQty'].includes(item['property'])) {
          sums[index] = this.detailDrawerHeader.billAdjustQty;
          return;
        }
        if (item['property'] && item['property'].match(/amt|totalAmt/i)) {
          if (this.locationSearch.tag.match(/PKD/i)) {
            sums[index] = this.detailDrawerHeader.adjustTotalAmt;
          } else {
            sums[index] = this.detailDrawerHeader.totalAmt;
          }
          return;
        }
      })
      this.$nextTick(() => {
        this.$refs.detailDrawerTable.doLayout()
      })
      return sums
    },
    // 出,入,访销 合计
    getTableSummariesNew({ columns }) {
      const sums = []
      columns.forEach((column, index) => {
          for (let k in this.summariesCK) {
              columns.forEach((column, index) => {
                  if (index == 1) {
                      sums[index] = '合计'
                      return
                  }
                  if (column.property == k) {
                      sums[index] = this.summariesCK[k]
                      return
                  }
              })
          }
        })
      this.$nextTick(() => {
        this.$refs.detailDrawerTable.doLayout()
      })
      return sums
    },
    filterMethod({ itemName }) {
      let profitAndloss = itemName.length ? itemName.map(i => "'" + i + "'").join(",") : ''
      this.params['profitAndloss'] = profitAndloss
      this.getDetailInfo()
      console.log(profitAndloss)
    },
    operateBill(name, billNo, tag = '') {
      this.$emit("operateBill", { name: name, billNo: billNo, tag: tag })
    },
    detailsHandle() {
      // console.log(this.detailDrawerHeader)
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      if(this.detailDrawerHeader.sourceBillType == 'TG') {
        top.addPanel('采购退货详情', `/yunsierp3/index.html#/enterPage/purchaseReturnEntry?billNo=${this.detailDrawerHeader.sourceBillNo}&billType=${this.detailDrawerHeader.sourceBillType}`, width, height, true)
      }
    },
    getBillColor(sourceBillType) {
      return sourceBillType === 'TG' ? '#409EFF' : 'initial';
    },
    /** 
      *去除无效单位 比如0件1袋  将 0件 去掉，保留 1袋，若0大0中0小，保留0小
        大单位显示：(不为0) || (大单位转换比为1)
        中单位显示：不为0
        小单位显示: (不为0) || (大单位转换比不为1 && 大单位为0 && (中单位为0 || 中单位不存在))
      *@param {string} type - 类型 sal 大单位 mid 中单位 inv 小单位
      *@param {number} salUnitConversion - 大单位转换比
      *@param {number} salUnitQty - 大单位数量
      *@param {number} midUnitQty - 中单位数量
      *@param {number} invUnitQty - 小单位数量
      *@param {string} midUnitName - 中单位名称
      *@return {boolean}
    */
    getUnit(type, salUnitConversion, salUnitQty, midUnitQty, invUnitQty, midUnitName) {
      if (type == 'sal') {
        if (salUnitQty != 0 || salUnitConversion == 1) return true
      } else if (type == 'mid') {
        if (midUnitQty != 0) return true
      } else if (type == 'inv') {
        if (invUnitQty != 0 || (salUnitConversion != 1 && salUnitQty == 0 && (midUnitQty == 0 || !midUnitName))) return true
      }
      return false
    },
    // adjustQty4Sal调整数
    // onhandQty4Sal账面数
    getAdjustQty ({ row }, tag) {
      let { salUnitConversion = 0, midUnitConversion = 0, salUnitQty = 0, midUnitQty = 0, invUnitQty = 0, onhandQty4Inv = 0, onhandQty4Mid = 0, onhandQty4Sal = 0, adjustQty4Sal = 0, adjustQty4Mid = 0, adjustQty4Inv = 0, invUnitPrice = 0, availableQty = 0 } = row
      let sal = 0, mid = 0, inv = 0, realQty = 0, adjustQty = 0
      // 将折算小单位数量inv重新分配给大中小单位
      let invTransformationt = (inv = 0) => {
        let arr = [Number(salUnitConversion)]
        if (Number(midUnitConversion)) {
          arr.push(Number(midUnitConversion))
        }
        return arr.reduce(({ salTran, midTran, invTran }, item, index) => {
          /**
            * 有大单位转换比:
            * 1.大单位数量 = （折算小单位数量/大单位转换比）取整
            * 1.1 如果大单位有小数位，小单位数量 = 小数位*大单位转换比
            * 1.2 如果没有小数位，小单位数量 = 0
            * 有中单位转换比
            * 1.中单位数量 = （1.1计算的小单位数量/中单位转换比）取整
            * 1.1 如果中单位有小数位，小单位数量 = 小数位*中单位转换比
            * 1.2 如果没有小数位，小单位数量 = 0
            */
          if (index == 0) {
            let tempSal = (invTran / item)
            salTran = Math.trunc(tempSal)
            // 获取tempSal的小数点后的数
            let fractSal = (tempSal - salTran)
            invTran = Math.abs(fractSal) ? (fractSal * item) : 0
          } else if (index == 1) {
            let tempMid = (invTran / item)
            midTran = Math.trunc(tempMid)
            // 获取tempMid的小数点后的数
            let fractMid = (tempMid - midTran)
            invTran = Math.abs(fractMid) ? (fractMid * item) : 0
          }
          return { salTran: Number(salTran.toFixedRoundUp(2)), midTran: Number(midTran.toFixedRoundUp(2)), invTran: Number(invTran.toFixedRoundUp(2)) }
        }, { salTran: 0, midTran: 0, invTran: inv })
      }
      sal = (Number(adjustQty4Sal) + Number(onhandQty4Sal)) * Number(salUnitConversion)
      mid = (Number(adjustQty4Mid) + Number(onhandQty4Mid)) * Number(midUnitConversion)
      inv = Number(adjustQty4Inv) + Number(onhandQty4Inv)
      realQty = Number((sal + mid + inv).toFixedRoundUp(2))
      adjustQty = Number(adjustQty4Sal) * Number(salUnitConversion) + Number(adjustQty4Mid) * Number(midUnitConversion) + Number(adjustQty4Inv)
      let adjustTran = invTransformationt(adjustQty)
      let realTran = invTransformationt(realQty)
      // 账面数折算小单位数量
      let onhandQty = (() => {
        let sal = (Number(onhandQty4Sal) * Number(salUnitConversion))
        let mid = (Number(onhandQty4Mid) * Number(midUnitConversion))
        let inv = Number(onhandQty4Inv)
        return (Number(sal + mid + inv).toFixedRoundUp(2) || 0)
      })()
      let onhandTran = invTransformationt(onhandQty)
      let returnObj = {}
      if (salUnitConversion == 1) {
        returnObj['adjustQty4Sal'] = adjustQty
        returnObj['salUnitQty'] = realQty
        returnObj['onhandQty4Sal'] = onhandQty
      } else {
        returnObj['adjustQty4Sal'] = adjustTran.salTran
        returnObj['adjustQty4Mid'] = adjustTran.midTran
        returnObj['adjustQty4Inv'] = adjustTran.invTran

        returnObj['salUnitQty'] = realTran.salTran
        returnObj['midUnitQty'] = realTran.midTran
        returnObj['invUnitQty'] = realTran.invTran

        returnObj['onhandQty4Sal'] = onhandTran.salTran
        returnObj['onhandQty4Mid'] = onhandTran.midTran
        returnObj['onhandQty4Inv'] = onhandTran.invTran
      }
      return Number((Number(returnObj[tag]) || 0).toFixedRoundUp(2))
    },
  }
}
</script>

<style scoped lang="less">
.customer-box {
  width: 100%;
  /* height: calc(100% - 90px); */
  height: 100%;
}

.customer-scroll {
  /* height: calc(100% - 32px); */
  height: 100%;
}

.customer-img-box {
  padding: 15px 15px 0;
  height: calc(100% - 30px);
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-gap: 10px;
}

.customer-img-item {
  width: 180px;
  padding: 8px 8px 0;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px rgba(204, 204, 204, 0.7);
  margin-bottom: 15px;
}

.customer-img-img {
  width: 180px;
  height: 240px;
  margin-bottom: 8px;
  position: relative;
}

.customer-img-item .el-image {
  width: 180px;
  height: 240px;
}

.zanwu {
  text-align: center;
  font-size: 14px;
  color: #999;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-40%, -50%);
}

.el-col {
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  label {
    display: inline-block;
    width: 63px;
    text-align: right;
    margin-right: 6px;
  }
}

.el-table {
  .index {
    div {
      padding: 0;
      text-align: center;
    }
  }
}

.tips {
  position: fixed;
  right: 10px;
  top: 6px;
}

.barandArrear_top {
  padding: 0 12px 10px;

  p {
    font-size: 14px;
    color: #F56C6C;
    margin: 0;
    line-height: 20px;
  }
}
</style>